import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../utils/analytics';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-[#050505] sticky top-0 z-50 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <img 
              src="/logo192.png" 
              alt="CrowdOne Logo" 
              className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
            />
            <h1 className="text-xl sm:text-2xl font-bold text-white">CrowdOne</h1>
          </Link>
          
          {/* Desktop Links - Hidden on mobile */}
          <div className="hidden md:flex items-center gap-4 sm:gap-6">
            <Link
              to="/blog"
              onClick={() => trackButtonClick('Navigation - Blog', { location: 'desktop' })}
              className="text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium whitespace-nowrap"
            >
              Blog
            </Link>
            <Link
              to="/faq"
              onClick={() => trackButtonClick('Navigation - FAQ', { location: 'desktop' })}
              className="text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium whitespace-nowrap"
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              onClick={() => trackButtonClick('Navigation - Contact', { location: 'desktop' })}
              className="text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium whitespace-nowrap"
            >
              Contact Us
            </Link>
            <a
              href="/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackButtonClick('Navigation - Terms', { location: 'desktop' })}
              className="text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium whitespace-nowrap"
            >
              Terms & Conditions
            </a>
            <a
              href="/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackButtonClick('Navigation - Privacy', { location: 'desktop' })}
              className="text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium whitespace-nowrap"
            >
              Privacy Policy
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => {
              toggleMenu();
              trackButtonClick('Navigation - Mobile Menu Toggle', { is_open: !isMenuOpen });
            }}
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5 focus:outline-none"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span
              className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
                isMenuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            />
            <span
              className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
                isMenuOpen ? 'opacity-0' : ''
              }`}
            />
            <span
              className={`block w-6 h-0.5 bg-white transition-all duration-300 ${
                isMenuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            />
          </button>
        </div>

        {/* Mobile Collapsible Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            isMenuOpen ? 'max-h-56 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="py-4 space-y-3 border-t border-gray-800">
            <Link
              to="/blog"
              className="block text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium"
              onClick={() => {
                setIsMenuOpen(false);
                trackButtonClick('Navigation - Blog', { location: 'mobile' });
              }}
            >
              Blog
            </Link>
            <Link
              to="/faq"
              className="block text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium"
              onClick={() => {
                setIsMenuOpen(false);
                trackButtonClick('Navigation - FAQ', { location: 'mobile' });
              }}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className="block text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium"
              onClick={() => {
                setIsMenuOpen(false);
                trackButtonClick('Navigation - Contact', { location: 'mobile' });
              }}
            >
              Contact Us
            </Link>
            <a
              href="/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium"
              onClick={() => {
                setIsMenuOpen(false);
                trackButtonClick('Navigation - Terms', { location: 'mobile' });
              }}
            >
              Terms & Conditions
            </a>
            <a
              href="/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-white hover:text-[#4ADE80] transition-colors duration-200 text-sm font-medium"
              onClick={() => {
                setIsMenuOpen(false);
                trackButtonClick('Navigation - Privacy', { location: 'mobile' });
              }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
